export const uk = {
    'empty-rate': 'Не указана',
    title: 'Редактирование ставки'
};
